export default function HowWeWork() {
  const steps = [
    {
      number: '01',
      title: 'Preconstruction',
      description: 'Collaborative planning, budgeting, and value engineering before ground breaks.',
      icon: 'ri-draft-line',
    },
    {
      number: '02',
      title: 'Construction',
      description: 'Expert project management from groundbreaking to ribbon cutting.',
      icon: 'ri-hammer-line',
    },
    {
      number: '03',
      title: 'Project Controls',
      description: 'Schedule oversight, quality assurance, and transparent reporting throughout.',
      icon: 'ri-file-list-3-line',
    },
    {
      number: '04',
      title: 'Warranty Service',
      description: 'Ongoing support and service for all completed projects.',
      icon: 'ri-shield-check-line',
    },
  ];

  return (
    <section className="bg-white py-24">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-20">
          <h2 className="text-4xl lg:text-5xl font-bold text-[#1A1A1A] mb-4">
            How We Work
          </h2>
          <div className="w-24 h-1 bg-[#C5A55A] mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Our proven process ensures quality, transparency, and success from start to finish.
          </p>
        </div>

        {/* Steps Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {/* Connector Line */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-16 left-[calc(50%+40px)] w-[calc(100%-80px)] h-0.5 bg-[#C5A55A]/30"></div>
              )}

              {/* Step Card */}
              <div className="relative bg-white p-8 rounded-lg border border-gray-200 hover:border-[#C5A55A] transition-all duration-300 hover:shadow-xl">
                {/* Number Badge */}
                <div className="absolute -top-4 left-8 bg-[#C5A55A] text-[#1A1A1A] w-12 h-12 rounded-full flex items-center justify-center font-bold text-lg">
                  {step.number}
                </div>

                {/* Icon */}
                <div className="w-16 h-16 flex items-center justify-center mb-6 mt-4">
                  <i className={`${step.icon} text-5xl text-[#C5A55A]`}></i>
                </div>

                {/* Content */}
                <h3 className="text-xl font-bold text-[#1A1A1A] mb-4">
                  {step.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}